import { stateSchema } from './State';
import { createMessage, createMessages, SB } from '@play-co/replicant';
import { Inventory } from './buruburu/inventory';
import { Admin } from './admin';
import { Gifts } from './buruburu/gifts';
import { Social } from './social';
import { Visit } from './visit';
import { Pet } from './buruburu/pet';
import { Duo } from './duo';
import HistoryMessages from './buruburu/history/history.messages';

export default createMessages(stateSchema)({
  ...Inventory.messages,
  ...Admin.messages,
  ...Gifts.messages,
  ...Social.messages,
  ...Visit.messages,
  ...Pet.messages,
  ...Duo.messages,
  ...HistoryMessages,

  // deprecated messages
  /**
   * @deprecated
   */
  applyAttributeDecay: createMessage(
    SB.object({
      attribute: SB.tuple([
        'stomach',
        'love',
        'dirtiness',
        'urine',
        'toothAcidity',
      ]),
      amount: SB.number(),
    }),
    () => {
      // no-op
    },
  ),

  /**
   * @deprecated
   */
  setStatusEffects: createMessage(
    SB.object({
      asleep: SB.boolean().optional(),
      evolving: SB.boolean().optional(),
      sick: SB.boolean().optional(),
      toothDecay: SB.boolean().optional(),
      scared: SB.boolean().optional(),
    }),
    () => {
      // no-op
    },
  ),

  /**
   * @deprecated
   */
  modifyGems: createMessage(SB.number(), (state, amount) => {
    if (amount >= 0) {
      Inventory.modifiers(state).addFreeGems(amount);
    } else {
      Inventory.modifiers(state).consumeGems(amount);
    }
  }),
});
